@if (isResourceValid) {
  <app-table-actions
    (doSearch)="onDoSearch($event)"
    [isLiveSearch]="isLiveSearch"
    [showCreateMenu]="showCreateMenu"
    [showCreateYAML]="showCreateYAML"
    [showCreateFolder]="showCreateFolder"
    [showCreateManagedService]="showCreateManagedService"
    [showCreateResourceGroup]="showCreateResourceGroup"
    [showCreateServiceInstance]="showCreateServiceInstance"
    [showCreateApplication]="showCreateApplication"
    [systemResourcesByGroup]="systemResourcesByGroup"
    [applicationResources]="applicationResources"
    [loadingFinished]="loadingFinished"
    [currentPath]="currentPath"
    [currentOrg]="currentOrg"
    [resourceType]="resourceType"
    [advancedSearchOpen]="advancedSearchOpen"
    [advancedSearchReady]="advancedSearchReady"
    (createItem)="onCreateItem($event)"
    (createApplication)="onCreateApplication($event)"
    (createGenericResource)="onCreateGenericResource()"
    (createServiceInstance)="onCreateServiceInstance($event)"
    (advancedSearchToggled)="onAdvancedSearchToggled($event)"
  ></app-table-actions>
}
@if (isResourceValid) {
  <fd-panel [fixed]="true">
    @if (advancedSearchOpen) {
      <div class="panel-title-container">
        <app-icon class="header-icon" icon="filter" size="lg"></app-icon>
        <h5 class="header-text" fd-panel-title>Filtered View ({{ resultCount }}): </h5>
        <div class="filter-view-dropdown-wrapper">
          <app-saved-filter-views
            [disabled]="savedFilterViewsDisabled"
            [currentViewName]="filterViewName"
            [organizationPath]="organizationPath"
            (viewSelected)="onViewSelected($event)"
          ></app-saved-filter-views>
        </div>
      </div>
    }
    @if (!advancedSearchOpen) {
      <div class="panel-title-container">
        <app-icon class="header-icon" [icon]="glyph" size="lg"></app-icon>
        <h5 class="header-text" fd-panel-title>{{ text }}</h5>
      </div>
    }
    <ng-container *ngTemplateOutlet="body"></ng-container>
  </fd-panel>
}
